import React, { memo } from "react";

import { ScoreConfig } from "types/PatientRegion";
import { RegionInfoItems } from "./RegionInfoItems";
import { icons } from "constants/icons";

type Props = {
  title: string;
  subtitle?: string;
  lastExam: string;
  score?: ScoreConfig;
  painScale?: number | string;
  week?: number | string;
  patientLastExamDate: string | null;
  showRegionInfo?: boolean;
};
export const RegionBlock = memo(
  ({
    title,
    subtitle = "",
    lastExam,
    score,
    painScale,
    week,
    patientLastExamDate,
    showRegionInfo = true,
  }: Props) => {
    return (
      <div className="flex flex-col">
        <div className="flex space-x-2 items-center">
          <img src={icons.patientShoulder} alt="status" />
          <div className="flex flex-col">
            <h4 className="text-grayDark leading-4">Region</h4>
            <p className="flex items-baseline space-x-1  text-grayDark">
              <strong className="text-[28px] text-black leading-6">
                {title}
              </strong>
              <p className="text-xl ">({subtitle?.toLocaleLowerCase()})</p>
            </p>
          </div>
        </div>

        {showRegionInfo && (
          <RegionInfoItems
            classNames="mt-7"
            lastExamDate={lastExam[lastExam.length - 1]}
            patientLastExamDate={patientLastExamDate}
            score={score}
            painScale={painScale}
            weekNumber={week}
          />
        )}
      </div>
    );
  }
);
